import { render, staticRenderFns } from "./TableMixin.vue?vue&type=template&id=069bf984&"
import script from "./TableMixin.vue?vue&type=script&lang=js&"
export * from "./TableMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports